module.exports = __webpack_public_path__ + "img/funOff.a8714c23.png";